import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '../../lib/utils';
import { popoverArrowVariants, popoverContentVariants } from './variants';

const Popover = ({ ...props }: PopoverPrimitive.Root.Props) => (
  <PopoverPrimitive.Root data-slot={'popover'} {...props} />
);

const PopoverTrigger = ({
  openOnHover = true,
  delay = 150,
  closeDelay = 150,
  ...props
}: PopoverPrimitive.Trigger.Props) => (
  <PopoverPrimitive.Trigger
    data-slot={'popover-trigger'}
    openOnHover={openOnHover}
    delay={delay}
    closeDelay={closeDelay}
    {...props}
  />
);

const PopoverContent = ({
  align = 'center',
  alignOffset = 0,
  side = 'bottom',
  sideOffset = 8,
  className,
  children,
  ...props
}: PopoverPrimitive.Popup.Props &
  Pick<
    PopoverPrimitive.Positioner.Props,
    'align' | 'alignOffset' | 'side' | 'sideOffset'
  >) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Positioner
      className={cn('isolate z-[500] outline-none')}
      align={align}
      alignOffset={alignOffset}
      side={side}
      sideOffset={sideOffset}
    >
      <PopoverPrimitive.Popup
        data-slot={'popover-content'}
        className={cn(popoverContentVariants(), className)}
        {...props}
      >
        <PopoverPrimitive.Arrow className={cn(popoverArrowVariants())} />
        {children}
      </PopoverPrimitive.Popup>
    </PopoverPrimitive.Positioner>
  </PopoverPrimitive.Portal>
);

const PopoverClose = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'button'> & PopoverPrimitive.Close.Props) => (
  <PopoverPrimitive.Close
    data-slot={'popover-close'}
    className={cn('absolute top-2 right-2', className)}
    {...props}
  />
);

export { Popover, PopoverClose, PopoverContent, PopoverTrigger };
